import { Component, DoCheck, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss']
})
export class SidemenuComponent implements DoCheck {
  private openarrow: boolean = false;
  private open: boolean = true;
  private masteropen: boolean = false;
  private btnareaHeight: number;
  private active: number;
  public childmenuHeight: any;
  private queryParam: string;
  private sessionStorage: string = 'true';
  private openMenu: boolean = false;
  @ViewChild('btnarea') btnarea: ElementRef;
  @ViewChild('menul0') menul0: ElementRef;
  @ViewChild('menul1') menul1: ElementRef;
  @ViewChild('menul2') menul2: ElementRef;
  @ViewChild('menul3') menul3: ElementRef;
  @ViewChild('menul4') menul4: ElementRef;
  @ViewChild('menul5') menul5: ElementRef;
  public isOperatorUser = false

  constructor(private router: Router) {
    // sessionStorage.setItem('open', 'true');

    setTimeout(() => {
      this.routerInit();
    }, 100);
  }

  routerInit() {
    if (this.router.url === '/wa1010' || this.router.url === '/wa1030' || this.router.url === '/wa0053?upload_objects_id=1') {
      this.childmenuHeight = this.menul0.nativeElement.clientHeight;
      this.active = 0;
    }
    if (this.router.url === '/wa3010' || this.router.url === '/wa3016' || this.router.url === '/wa9144' || this.router.url === '/wa3020' || this.router.url === '/wa3030' || this.router.url === '/wa3040' || this.router.url === '/wa0053?upload_objects_id=2' || this.router.url === '/wa3017' || this.router.url === '/wa3051?tab=0' || this.router.url === '/wa3921') {
      this.childmenuHeight = this.menul1.nativeElement.clientHeight;
      this.active = 1;
    }
    if (this.router.url === '/wa5010' || this.router.url === '/wa5020') {
      this.childmenuHeight = this.menul2.nativeElement.clientHeight;
      this.active = 2;
    }
    if (this.router.url === '/wa6010' || this.router.url === '/wa6030' || this.router.url === '/wa6020' || this.router.url === '/wa6060') {
      this.childmenuHeight = this.menul3.nativeElement.clientHeight;
      this.active = 3;
    }
    if (this.router.url === '/wa7010' || this.router.url === '/wa7011') {
      this.childmenuHeight = this.menul4.nativeElement.clientHeight;
      this.active = 4;
    }
    if (this.router.url === '/wa8005' || this.router.url === '/wa8010' || this.router.url === '/wa8004') {
      this.childmenuHeight = this.menul5.nativeElement.clientHeight;
      this.active = 5;
    }
  }

  ngDoCheck() {
    if (this.active !== undefined) {
      if (this.active === 0) {
        this.childmenuHeight = this.menul0.nativeElement.clientHeight + 45;
      }
      if (this.active === 1) {
        this.childmenuHeight = this.menul1.nativeElement.clientHeight + 45;
      }
      if (this.active === 2) {
        this.childmenuHeight = this.menul2.nativeElement.clientHeight + 45;
      }
      if (this.active === 3) {
        this.childmenuHeight = this.menul3.nativeElement.clientHeight + 45;
      }
      if (this.active === 4) {
        this.childmenuHeight = this.menul4.nativeElement.clientHeight + 45;
      }
      if (this.active === 5) {
        this.childmenuHeight = this.menul5.nativeElement.clientHeight + 45;
      }
    }

    this.queryParam = sessionStorage.getItem('queryParam');

    if (document.getElementsByTagName('article').length === 1) {
      if (sessionStorage.getItem('open') === 'true') {
        document.getElementsByTagName('article')[0].className = 'page-block shortwidth';
        this.open = true;
      } else {
        document.getElementsByTagName('article')[0].className = 'page-block';
        this.open = false;
      }

      if (sessionStorage.getItem('open') === 'true') {
        this.open = true;
        this.openMenu = true;
      } else {
        this.open = false;
        this.openMenu = false;
      }
    }

    if (sessionStorage.getItem('isShowOwnerSelect') === 'true') {
      this.sessionStorage = sessionStorage.getItem('isShowOwnerSelect');
    } else {
      this.sessionStorage = '';
    }
    this.btnareaHeight = this.btnarea.nativeElement.clientHeight;
  }

  openClick() {
    if (this.openMenu === false) {
      sessionStorage.setItem('open', 'true');
      this.openMenu = true;
    } else {
      sessionStorage.removeItem('open');
      this.openMenu = false;
    }
  }

  systemMenu(type) {
    if (this.active === type) {
      this.active = null;
    } else {
      this.active = type;
    }
  }

  MasterMenu() {
    const loginResult = JSON.parse(sessionStorage.getItem('loginResult'))
    this.isOperatorUser = loginResult.user.roleId === 2
    if (this.masteropen === false) {
      this.masteropen = true;
    } else {
      this.masteropen = false;
    }
  }

  openWa3051 () {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/wa3051'], {
        queryParams: {
          tab: 0
        }
      })
    );
    window.open(url, '_blank');
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/menu/sidemenu/sidemenu.component.ts